export const formDefaultValues = {
  email: '',
  password: '',
  repeatPassword: '',
  firstname: '',
  lastname: '',
  mobile: '',
  centreName: '',
  category: '',
  botTrap: '',
}
